import React from "react";
import * as PropTypes from "prop-types";

class NavBar extends React.Component {
    render() {
        return <nav id="nav-menu-container">
            <ul className="nav-menu">
                {this.props.options.map((option, index) =>
                    <li className={(this.props.activeIndex === index ? "menu-active" : "") + " " + (option.bigButton ? "buy-tickets" : "")}>
                        <a href={option.href}>{option.label}</a>
                    </li>
                )}
            </ul>
        </nav>;
    }
}

NavBar.propTypes = {
    options: PropTypes.arrayOf(PropTypes.any),
    activeIndex: PropTypes.number
};

class Logo extends React.Component {
    render() {
        return <div id="logo" className="pull-left">
            <a href={this.props.href} className="scrollto">
                <img src={this.props.logoSrc} alt={this.props.logoAlt} title=""/>
            </a>
        </div>;
    }
}

Logo.propTypes = {
    href: PropTypes.string,
    logoSrc: PropTypes.string,
    logoAlt: PropTypes.string
};

let activeIndex = 0;

export class Header extends React.Component {
    render() {
        return <header id="header">
            <div className="container">
                <Logo href={this.props.logoHref} logoSrc={this.props.logoSrc} logoAlt={this.props.logoAlt}/>
                <NavBar options={this.props.options} activeIndex={this.props.activeIndex}/>
            </div>
        </header>;
    }
}

Header.propTypes = {
    logoAlt: PropTypes.string,
    logoHref: PropTypes.string,
    logoSrc: PropTypes.string,
    options: PropTypes.array,
    activeIndex: PropTypes.number
};